import { createMemoryHistory, createRouter, createWebHistory } from 'vue-router'
import { type RouterOptions } from 'vue-router'
import Auth from '@/views/auth/routes'
import HomeView from '@/views/HomeView.vue'
import Config from '@/utils/config'
import { auth } from '@/router/middleware/Auth'

const router = createRouter({
  history: Config.ssr
    ? createMemoryHistory(import.meta.env.BASE_URL)
    : createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/:locale(.{2})?',
      children: [
        {
          path: '',
          name: 'home',
          component: HomeView,
          meta: { middleware: [auth()], ssr: false },
        },
        {
          path: 'auth',
          children: Auth,
        },
        {
          path: 'play',
          name: 'play',
          component: () => import('@/views/Play.vue'),
          meta: { middleware: [auth()], ssr: false },
        },
      ],
    },
  ],
  scrollBehavior: (to, from, savedPosition) => {
    const scrollContainer = document.querySelector('.scroll-container');
    if (!scrollContainer) return savedPosition ?? { left: 0, top: 0 }

    if (savedPosition) {
      scrollContainer.scrollTo(savedPosition)
      return false
    }

    if (to.hash && document) {
      const el = document.getElementById(to.hash)
      if (el) {
        el.scrollIntoView()
        return false
      }
    }

    if (to.name !== 'home') {
      scrollContainer.scrollTo({ left: 0, top: 0 })
    }

    return false
  },
} as RouterOptions)

export default router
